module.exports = __webpack_public_path__ + "static/media/butcher-4.31bd0e49.png";